export const DataBaseKeys = {
  Token: 'qwertyuiop',
  User: 'poiuytrewq',
};
